import { appConfig as hamaramall_v1_appConfig } from './hamaramall/v1/app.config';
import { tailwindConfig as hamaramall_v1_tailwindConfig } from './hamaramall/v1/tailwind.config';

import { appConfig as hamaramall_v2_appConfig } from './hamaramall/v2/app.config';
import { tailwindConfig as hamaramall_v2_tailwindConfig } from './hamaramall/v2/tailwind.config';

import { appConfig as iocl_v1_uiConfig } from './iocl/v1/app.config';
import { tailwindConfig as iocl_v1_themeConfig } from './iocl/v1/tailwind.config';

import { appConfig as onemall_v1_appConfig } from './onemall/v1/app.config';
import { tailwindConfig as onemall_v1_tailwindConfig } from './onemall/v1/tailwind.config';

import { appConfig as cub_v1_appConfig } from './cub/v1/app.config';
import { tailwindConfig as cub_v1_tailwindConfig } from './cub/v1/tailwind.config';

import { appConfig as hpcl_v1_appConfig } from './hpcl/v1/app.config';
import { tailwindConfig as hpcl_v1_tailwindConfig } from './hpcl/v1/tailwind.config';

import { appConfig as oriens_v2_appConfig } from './oriens/v2/app.config';
import { tailwindConfig as oriens_v2_tailwindConfig } from './oriens/v2/tailwind.config';

import { appConfig as oneindiamall_v2_appConfig } from './oneindiamall/v2/app.config';
import { tailwindConfig as oneindiamall_v2_tailwindConfig } from './oneindiamall/v2/tailwind.config';


import { appConfig as nstore_v2_appConfig } from './nstore/v2/app.config';
import { tailwindConfig as nstore_v2_tailwindConfig } from './nstore/v2/tailwind.config';

import { appConfig as fintastics_v2_appConfig } from './fintastics/v2/app.config';
import { tailwindConfig as fintastics_v2_tailwindConfig } from './fintastics/v2/tailwind.config';
import { appConfig as hpcl_v2_appConfig } from './hpcl/v2/app.config';
import { tailwindConfig as hpcl_v2_tailwindConfig } from './hpcl/v2/tailwind.config';

export const themes: Record<string, ThemeConfig> = {
  hamaramall_v1: {
    appConfig: hamaramall_v1_appConfig,
    tailwindConfig: hamaramall_v1_tailwindConfig
  },
  hamaramall_v2: {
    appConfig: hamaramall_v2_appConfig,
    tailwindConfig: hamaramall_v2_tailwindConfig
  },
  iocl_v1: {
    appConfig: iocl_v1_uiConfig,
    tailwindConfig: iocl_v1_themeConfig
  },
  onemall_v1: {
    appConfig: onemall_v1_appConfig,
    tailwindConfig: onemall_v1_tailwindConfig
  },
  cub_v1: {
    appConfig: cub_v1_appConfig,
    tailwindConfig: cub_v1_tailwindConfig
  },
  hpcl_v1: {
    appConfig: hpcl_v1_appConfig,
    tailwindConfig: hpcl_v1_tailwindConfig
  },
  oriens_v2: {
    appConfig: oriens_v2_appConfig,
    tailwindConfig: oriens_v2_tailwindConfig
  },
  oneindiamall_v2: {
    appConfig: oneindiamall_v2_appConfig,
    tailwindConfig: oneindiamall_v2_tailwindConfig
  },
 
  nstore_v2: {
    appConfig: nstore_v2_appConfig,
    tailwindConfig: nstore_v2_tailwindConfig
  },
  
  fintastics_v2: {
    appConfig: fintastics_v2_appConfig,
    tailwindConfig: fintastics_v2_tailwindConfig
  },
  hpcl_v2: {
    appConfig: hpcl_v2_appConfig,
    tailwindConfig: hpcl_v2_tailwindConfig
  },
};
